module.exports = __webpack_public_path__ + "static/media/header_contact.17112ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_contact.jpg
// module id = 315
// module chunks = 1